import { render, staticRenderFns } from "./StoreItemTabs.vue?vue&type=template&id=46436f0c&"
import script from "./StoreItemTabs.vue?vue&type=script&lang=js&"
export * from "./StoreItemTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports